import script from "./addOrEditCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./addOrEditCategory.vue?vue&type=script&setup=true&lang=ts"

import "./addOrEditCategory.vue?vue&type=style&index=0&id=438575d0&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438575d0"]])

export default __exports__